import ChannelsV2LargeCard from './ChannelsV2Card'
export default ChannelsV2LargeCard
